// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useState, useEffect } from 'react'
import './ICDCodesSection.scss'
import { Code } from 'ui_kit_qmd'
import { text } from './Constants'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const ICDCodesSection = ({ visitICDCodes }) => {
  const [codes, setCodes] = useState([])
  useEffect(() => {
    if (visitICDCodes?.length) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setCodes([...visitICDCodes].sort((a, b) => a.Code.localeCompare(b.Code)))
    } else {
      setCodes([])
    }
  }, [visitICDCodes])
  return (
    <div className='icd10-code-container'>
      <div className='icd10-code-header'>
        <label htmlFor='null' className='icd10-code-title'>
          {text.TITLE}
        </label>
      </div>

      <div className='icd10-code-inner-container'>
        {codes.length ?
          <div className='icd10-code-list-container'>
            {codes.map((item, index) => (
              <Code
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                code={item.Code}
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                description={item.Description}
                isReadOnly
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                id={item.IcdCodeId}
                index={index}
                isDetailsMode
              />
            ))}
          </div>
        : <div className='icd10-code-empty-parent'>
            <div className='icd10-code-empty-container'>
              <label className='icd10-code-empty-label' htmlFor='null'>
                {text.NO_CODES}
              </label>
            </div>
          </div>
        }
      </div>

      <div className='icd10-code-line' />
    </div>
  )
}
